import { useQuery } from "react-query"
import { getCurrentRainData, getCurrentWeatherData, getRainData, getWeatherData, getWeatherForecastData } from "./weatherDataUrls"

const weatherData = (query) => {
  return useQuery(["weatherData", query], () => getWeatherData(query), {
    refetchOnWindowFocus: false,
  })
}

const rainData = (query) => {
  return useQuery(["rainData", query], () => getRainData(query), {
    refetchOnWindowFocus: false,
  })
}

const weatherForecastData = (query) => {
  return useQuery(["weatherForecastData", query], () => getWeatherForecastData(query), {
    refetchOnWindowFocus: false,
  })
}

const currentWeatherData = (query) => {
  return useQuery(["currentWeatherData", query], () => getCurrentWeatherData(query), {
    refetchOnWindowFocus: false,
  })
}

const currentRainData = (query) => {
  return useQuery(["currentRainData", query], () => getCurrentRainData(query), {
    refetchOnWindowFocus: false,
  })
}

const useWeatherDataQuery = {
  weatherData,
  currentWeatherData,
  weatherForecastData,
  rainData,
  currentRainData
};

export default useWeatherDataQuery
